import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { environment } from 'environments/environment';
import { UserService } from 'shared/services/User/user.service';


@Injectable()
export class SsInventoryService {
  token;
  _PRICE_RANGE = [];
  _SECTIONS = [];

  constructor(private http: Http, private us: UserService) {
    this.token = this.us.user.token;
  }

  getNewPurchase() {
    const userParams = new FormData();
    const headers = new Headers();
    userParams.append('version', '999');
    return this.http.post(environment.API_BASE_URL + '/inventory/newPurchase', userParams, { headers: headers }).map(res => res.json())
      .catch(this.handleError);
  }

  getInventory() {
    const headers = new Headers();
    const userParams = new FormData();
    userParams.append('version', '999');
    return this.http.post(environment.API_BASE_URL + '/inventory/getUploadInventory', userParams, { headers: headers }).map(res => {
      return res.json();
    })
      .catch(err => {
        return Observable.throw(err.json());
      });
  }

  getPackagedata(ss_event_id) {
    const headers = new Headers();
    headers.append('token', this.us.user.token);
    const userParams = new FormData();
    userParams.append('ss_pk', ss_event_id); // ss_pk
    return this.http.post(environment.API_BASE_URL + '/inventory/packageDetails', userParams, { headers: headers }).map(res => {
      return res.json();
    })
      .catch(err => {
        return Observable.throw(err.json());
      });
  }

  getTeams(league) {
    const headers = new Headers();
    const userParams = new FormData();
    userParams.append('league', league);
    return this.http.post(environment.API_BASE_URL + '/inventory/teams', userParams, { headers: headers }).map(res => res.json())
      .catch(this.handleError);
  }

  getPriceRange(venderId, event_name) {
    const headers = new Headers();
    const request: any = {};
    request.event_name = event_name;
    request.vendor_id = venderId;
    return this.http.post(environment.API_BASE_URL + '/cronus/pricerange', request, { headers: headers }).map(res => {
      this._PRICE_RANGE = res.json().pricerange;
      return res.json();
    })
      .catch(err => {
        return Observable.throw(err);
      });
  }

  getSections(event_name) {
    const headers = new Headers();
    const request: any = {};
    request.event_name = event_name;
    request.vendor_id = 1;
    return this.http.post(environment.API_BASE_URL + '/cronus/sections', request, { headers: headers }).map(res => {
      this._SECTIONS = res.json().section;
      return res.json();
    })
      .catch(err => {
        return Observable.throw(err);
      });

  }

  getBestSeats(data) {
    const headers = new Headers();
    headers.append("token", this.us.user.token);
    const request: any = {};
    request.event_name = data.event_name;
    request.vendor_id = data.vendor_id;
    request.seats_needed = data.seats_needed;
    request.num_seats_sec = data.seats_needed;
    request.num_levels = 1;
    request.pick_quality = 2;
    // request.num_seats_sec = data.num_seats_sec;
    request.section_name = data.section_name;
    return this.http.post(environment.API_BASE_URL + '/cronus/bestSeatsv2', request, { headers: headers }).map(res => {
      return res.json();
    })
      .catch(err => {
        return Observable.throw(err);
      });
  }

  holdSeatForPreauth(seat_block, group_size, team_id, event_name) {
    const headers = new Headers();
    headers.append('token', this.token);
    const userParams = new FormData();
    userParams.append('team_id', team_id);
    userParams.append('event_name', event_name);
    userParams.append('group_size', group_size);
    userParams.append('seat_id_arr', seat_block.seat_ids_arr.toString());
    return this.http.post(environment.API_BASE_URL + '/vendors/ticketmaster/holdSeatForPreauth', userParams,
      { headers: headers }).map(res => {
        return res.json();
      }, err => {
        console.log(err.json());
        return Observable.throw(err.json());
      });
  }

  getSeasonPreview(event_id) {
    const headers = new Headers();
    headers.append('token', this.token);
    const request: any = {};
    request.event_id = event_id;
    return this.http.post(environment.API_BASE_URL + '/vendors/ticketmaster/seasonPreview', request, { headers: headers }).map(res => {
      return res.json();
    })
      .catch(err => {
        return Observable.throw(err);
      });

  }

  getJSON(): Observable<any> {
    return this.http.get('./assets/files/view-data.json').map(res => {
      return res.json();
    });
  }

  getPublicInventory() {
    const headers = new Headers();
    const userParams = new FormData();
    return this.http.post(environment.API_BASE_URL + '/inventory/publicGroups', userParams, { headers: headers }).map(res => {
      return res.json();
    })
      .catch(err => {
        return Observable.throw(err.json());
      });
  }

  private handleError(error: Response) {
    console.log('Handle error called in inventory service... Printing error...');
    return Observable.throw(error.json() || 'Server Error');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/SS-Inventory/ss-inventory.service.ts